import React from 'react';
import { Instagram, Mail, Camera } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => {
  const { contact, hero } = mockData;
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'Instagram',
      url: contact.social.instagram,
      icon: Instagram,
      color: 'hover:text-pink-400'
    },
    {
      name: 'Email',
      url: `mailto:${contact.email}`,
      icon: Mail,
      color: 'hover:text-blue-400'
    }
  ];

  const quickLinks = [
    { name: 'Accueil', href: '#hero' },
    { name: 'À propos', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Portfolio', href: '#portfolio' },
    { name: 'Contact', href: '#contact' }
  ];

  const services = [
    'Sites web',
    'E-commerce',
    'Optimisation & SEO',
    'Production vidéo'
  ];

  const scrollToSection = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-12 grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={hero.logoNav}
                alt=""
                aria-hidden="true"
                className="h-10 w-auto object-contain shrink-0"
              />
              <div>
                <h3 className="text-xl font-bold">C² Productions</h3>
                <p className="text-red-400 text-sm font-medium">{hero.subtitle}</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Développeur web & vidéaste. Je conçois des sites performants et
              des contenus vidéo qui renforcent votre visibilité.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 ${social.color} transition-all duration-200 hover:scale-110`}
                  aria-label={social.name}
                >
                  <social.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Navigation</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-gray-300 text-sm">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contact</h4>
            <div className="space-y-4">
              <div>
                <p className="text-gray-400 text-sm mb-1">Email</p>
                <a 
                  href={`mailto:${contact.email}`}
                  className="text-red-400 hover:text-red-300 transition-colors text-sm"
                >
                  {contact.email}
                </a>
              </div>
              
              <div>
                <p className="text-gray-400 text-sm mb-1">Zone d'intervention</p>
                <p className="text-gray-300 text-sm">France métropolitaine</p>
              </div>

              <div>
                <p className="text-gray-400 text-sm mb-1">Spécialités</p>
                <p className="text-gray-300 text-sm">Web • E-commerce • Vidéo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800"></div>

        {/* Bottom Section */}
        <div className="py-6 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} C² Productions. Tous droits réservés.
            </p>
          </div>
          
          <div className="flex items-center space-x-6 text-sm text-gray-400">
            <span>Siret à venir</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
